import styled from 'styled-components';

export const Container = styled.div`
    padding: 20px;

    p {
        display: block;
    }

    h2 {
        display: block;
        margin-bottom: 5px;
        color: rgb(0, 107, 219);
    }

    label {
        display: block;
        margin-top: 20px;
        margin-bottom: 5px;
    }

    button {
        width: 120px;
        height: 40px;
        border-radius: 10px;
        background-color: rgb(0, 107, 219);
        color: whitesmoke;
        border: none;
        margin-top: 10px;
    }

    .passo {
        margin-bottom: 10px;
    }

    input, select {
        display: block;
        margin-top: 5px;
        box-sizing: border-box;
        width: 100%;
        padding: 10px;
        border: 2px solid rgb(0, 107, 219);
        border-radius: 10px;
        font-size: 15px;
        outline: 0;
        background-color: rgb(235, 235, 235);
    }

    .error {
        border: 2px solid red;
    }

    .captcha-wrapper {
        margin-top: 10px;
        margin-bottom: 10px;
    }
`;
